import { useEffect, useState } from "react";
import Header from "../components/Header/Header";

import Search from "../components/Search/Search";
import { Container, Row, Col } from "react-bootstrap";
import SidebarRight from "../components/SidebarRight/SidebarRight";

import { ReactSortable } from "react-sortablejs";
import ActivitiesCard from "../components/ActivitiesCard/ActivitiesCard";
import ParticipantsList from "../components/ParticipantsList";
import { getParticipants } from "../services/participantService";

let lastKey = 1000;

const Build = () => {
  const [participants, setParticipants] = useState([]);

  useEffect(() => {
    getParticipants().then((participants) => {
      console.log("videos fetched", participants);
      setParticipants(participants);
    });
  }, []);

  return (
    <Container>
      <Header title="Participants" />
      <Search />
      <ParticipantsList participants={participants}></ParticipantsList>
    </Container>
  );
};

export default Build;
